const { getAxiosInstance, getHeaders } = require('../connection');
const encodeQueryParams = require('../encodeQueryParams');

module.exports = {
    fetchUserData: function (userId) {
        return getAxiosInstance({
            method: 'GET',
            url:  '/users/' + encodeURIComponent(userId),
            json: true,
        }).then((response) => response.data);
    },
    updateUserProfile: function (userId, data) {
        return getAxiosInstance({
            method: 'PUT',
            url:  '/users/' + encodeURIComponent(userId),
            json: true,
            data,
        }).then((response) => response.data);
    },
    changePassword: function (oldPassword, newPassword) {
        return getAxiosInstance({
            method: 'PUT',
            url:  '/my_password',
            json: true,
            data: {
                old_password: oldPassword,
                password: newPassword,
            },
        }).then((response) => response.data);
    },
    uploadPhoto: function (userId, file) {
        let data = new FormData();
        data.append('photo', file);

        return getAxiosInstance({
            method: 'POST',
            url:  '/uploads?object=User&object_id=' + encodeURIComponent(userId) + '&format=jpg',
            headers: Object.assign(
                {
                    'Content-Type': 'multipart/form-data',
                },
                getHeaders()
            ),
            data,
        }).then((response) => response.data);
    },
    /**
     * Fetches meetings for a specific user and event.
     *
     * @param {string} userId - The ID of the user.
     * @param {string} eventId - The ID of the event.
     * @return {Promise<Object>} A promise that resolves to the data of the meetings.
     */
    fetchMeetings: function (userId, eventId) {
        const params = encodeQueryParams({
            event_id: eventId,
        });

        return getAxiosInstance({
            url:  '/users/' + encodeURIComponent(userId) + '/meetings' + params,
            method: 'GET',
            json: true,
        }).then((response) => response.data);
    },
    deleteAccount: function (userId) {
        return getAxiosInstance({
            url: ['users', encodeURIComponent(userId)].join('/'),
            method: 'DELETE',
            json: true,
        }).then((r) => r.data);
    },
    registerDevice: function (userId, subscription) {
        return getAxiosInstance({
            url: ['users', encodeURIComponent(userId), 'devices'].join('/'),
            method: 'POST',
            json: true,
            data: {
                api: 'webpush',
                device_id: subscription.endpoint,
                data: JSON.stringify(subscription),
            },
        }).then((r) => r.data);
    },
    unregisterDevice: function (userId, wooshiId) {
        return getAxiosInstance({
            url: ['users', encodeURIComponent(userId), 'devices', encodeURIComponent(wooshiId)].join('/'),
            method: 'DELETE',
            json: true,
        }).then((r) => r.data);
    },
};
